import { useRoutes } from "react-router-dom"
import { routes } from "./configs/router"

export default function Router() {
  return useRoutes(routes())
}
